import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SingleDepCheckbox from './SingleDepCheckbox';

var AppConfig = require('../../../config.json');

class OrderFormDepCheckboxes extends React.Component {
	constructor(props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);
		this.checkDispatch = this.checkDispatch.bind(this);
		this.state = {
			ticks: [],
			active:false,
			init:false
		};
	}
	componentDidMount() {
		if(this.props.checkoutDep.checkboxes.length===AppConfig.dep.checkboxes.length) {
			this.setState(
				{
					active:true
				},
				function() {
					this.checkDispatch();
				}
			);
		}
		this.setState({init:true});
	}

	checkDispatch() {
		this.props.handleStatus(this.state.active, this.state.ticks);
	}

	handleChange(id, status) {
		var ticks = this.state.ticks;
		if(!status) {
			ticks = ticks.filter(n => n!==id);
		} else {
			ticks.push(id);
		}
		ticks = [...new Set(ticks)];
		this.setState({
			active: ticks.length===AppConfig.dep.checkboxes.length,
			ticks: ticks
		},
			function() {
				this.checkDispatch();
			}
		);
		
	}


    render () {
        return (
          <div className={`orderformdepcheckboxes${this.state.active?" active":""}`}>
            {
				AppConfig.dep.checkboxes.map((item, n) =>
					<SingleDepCheckbox key={n} id={item.id} active={this.props.checkoutDep.checkboxes.includes(item.id)} desc={item.desc} onClick={this.handleChange} />
				)
			}
          </div>
        );
    }

}

OrderFormDepCheckboxes.propTypes = {
	/** Gets called when the user clicks on the item */
	onClick: PropTypes.func,
}

OrderFormDepCheckboxes.defaultProps = {
	/* eslint-disable no-console */
	onClick: event => {
		console.log('You have clicked a OrderFormDepCheckboxes Component!', event.target);
	},
	
}


const mapStateToProps = (state) => {
  return {
    checkoutDep: state.status.checkoutDep
  }
}
export default connect(
  mapStateToProps,
  null
)(OrderFormDepCheckboxes)







// WEBPACK FOOTER //
// ./src/components/molecules/OrderFormDepCheckboxes/OrderFormDepCheckboxes.js